module.exports = __webpack_public_path__ + "img/hero-visual-663b15.27d5a941.png";